export const vistaConstants = {
    VISTAS_GET_PU_SUCCESS: 'VISTAS_GET_PU_SUCCESS',
    VISTA_SELECCIONADA:'VISTA_SELECCIONADA',
    AGREGAR_VISTA_GENERADA:'AGREGAR_VISTA_GENERADA',
    VISTA_ELIMINADA:'VISTA_ELIMINADA',
    ACTUALIZAR_VISTA:'ACTUALIZAR_VISTA',
    VISTA_SENSOR_ELIMINADO:'VISTA_SENSOR_ELIMINADO',
    ACTUALIZAR_LAYOUT_VISTA:'ACTUALIZAR_LAYOUT_VISTA'
};
